import { Component, OnInit, Input, EventEmitter, Output, AfterViewInit, DOCUMENT } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-error-crr-add-claim-dates',
    templateUrl: './error-crr-add-claim-dates.component.html',
    styleUrls: ['./error-crr-add-claim-dates.component.css'],
    standalone: false
})
export class ErrorCrrAddClaimDatesComponent implements OnInit ,AfterViewInit {
  @Output() public collapseAddClaimDatesEditor = new EventEmitter<any>();
  @Input() inputLabel;
  @Input() inputValue;
  @Input() additionalClaimDateDesMapping;
  @Input() additionalClaimDateTimeData;
  @Input() changeBtnCls: string;
  @Input() getAddClaimDate;
  @Input() isInstitutional;
  @Input() encodeDateFormat;
  @Input() isServiceLineCategory:boolean;
  @Input() listData;


  public addClaimDateForm;
  public selectedQualifier:any ;
  public inputFieldQualifier = "096";
  public qualifier361 = "361";
  public codeThroughQulList: any = ['434','314','361'];
  viewLoaded :boolean;
  private dateFormat = 'yyyy-MM-dd';
  qualifierOptions = [];
  dtpInstitutionalQualifiers = [
    {value:'096' , label:'096-Discharge'},
    {value:'434' , label:'434-Statement'},
    {value:'435' , label:'435-Admission'},
    {value:'050' , label:'050-Received'}
    ];
  
  dtpProfessionalQualifiers = [
    {value:'431' , label:'431-Onset of Current Symptoms or Illness'},
    {value:'454' , label:'454-Initial Treatment'},
    {value:'304' , label:'304-Latest Visit or Consultation'},
    {value:'453' , label:'453-Acute Manifestation of a Chronic Conditio'},
    {value:'439' , label:'439-Accident'},
    {value:'484' , label:'484-Last Menstrual Period'},
    {value:'455' , label:'455-Last X-Ray'},
    {value:'471' , label:'471-Prescription'},
    {value:'314' , label:'314-Disability'},
    {value:'360' , label:'360-Initial Disability Period Start'},
    {value:'361' , label:'361-Initial Disability Period End'},
    {value:'297' , label:'297-Initial Disability Period Last Day Worked'},
    {value:'296' , label:'296-Initial Disability Period Return To Work'},
    {value:'435' , label:'435-Admission'},
    {value:'096' , label:'096-Discharge'},
    {value:'090' , label:'090-Report Start'},
    {value:'091' , label:'091-Report End'},
    {value:'444' , label:'444-First Visit or Consultation'},
    {value:'050' , label:'050-Received'}
    ];

  private profFormatMap = {
    '431': 'D8', '454': 'D8', '304': 'D8', '453': 'D8', '439': 'D8', '484': 'D8', '455': 'D8', '471': 'D8',
    '314': 'RD8', '360': 'D8', '361': 'D8', '297': 'D8', '296': 'D8', '435': 'D8', '096': 'D8', '090': 'D8',
    '091': 'D8', '444': 'D8', '050': 'D8'
  };
  private instFormatMap = {
    '096': 'TM', '434': 'RD8', '435': 'D8', '050': 'D8'
  };
  private instFormatMap435 = ['D8', 'DT'];

  constructor(private datePipe: DatePipe) { }

  ngOnInit() {
    this.qualifierOptions = this.isInstitutional ? this.dtpInstitutionalQualifiers : this.dtpProfessionalQualifiers;
    this.initializeForm();
  }

  ngAfterViewInit(){
    this.viewLoaded = true;
  }

  cancelClick() {
    const event = {
      type: 'cancel',
      field: this.inputLabel
    }
    this.collapseAddClaimDatesEditor.emit(event);
  }
  initializeForm() {
    const formControls:any= {
      dateTimeQualifier: new UntypedFormControl(
        this.qualifierOptions.find(q => q.value === this.inputValue.dateTimeQualifier) ?? null, 
        [Validators.required]
      ),
      dateFromField: new UntypedFormControl('', [this.getValidators('', '', this.displayCodeFrom(), '0')]),
      dateThroughField: new UntypedFormControl('', [this.getValidators('', '', this.displayCodeThroughDate(), '0')]),
      hoursField: new UntypedFormControl('', [this.getValidators('2', '^([0-1]?[0-9]|2[0-3])$', false, '0')]),
      minutesField: new UntypedFormControl('', [this.getValidators('2', '^([0-5]?[0-9]|[0-5][0-9])$', false, '0')]),
    }
    let DTTM_FormatValue = '';
    if (this.isDTTMFormatQualEditable()) {
      let suggested = '';
      if (this.isInstitutional && this.inputValue.dateTimeQualifier === '435') {
        suggested = this.instFormatMap435[0];
      } else if (this.isInstitutional) {
        suggested = this.instFormatMap[this.inputValue.dateTimeQualifier];
      } else {
        suggested = this.profFormatMap[this.inputValue.dateTimeQualifier];
      }
      if (this.listData["dateTimeFormatCode"]) {
        const found = this.listData["dateTimeFormatCode"].find(opt => opt.value === suggested);
        if (found) DTTM_FormatValue = found;
      }
      formControls["dateTimeFormatQual"] = new UntypedFormControl(DTTM_FormatValue, [this.getValidators("", "", true,'0')]);
    }
    this.addClaimDateForm = new UntypedFormGroup(formControls);
    if (this.displayInputField()) {
      const inputValues = this.isDTTMFormatQualEditable() ?  this.inputValue.dateTimePeriod.substr(8,4).match(/.{1,2}/g):this.inputValue.dateTimePeriod.match(/.{1,2}/g) ;
      if(inputValues){
        this.addClaimDateForm.controls.hoursField.setValue(inputValues[0]);
        this.addClaimDateForm.controls.minutesField.setValue(inputValues.length > 1 ? inputValues[1] : '');
      }
    }

    if (this.displayCodeFrom()) {
      this.addClaimDateForm.controls.dateFromField.setValue(this.datePipe.transform(this.getAddClaimDate(this.inputValue), this.dateFormat));
    }
    if (this.displayCodeThroughDate()) {
      this.addClaimDateForm.controls.dateThroughField.setValue(this.datePipe.transform((this.getAddClaimDate(this.inputValue, this.displayCodeFrom())),this.dateFormat));
    }
  }

  getValidators(maxLength, pattern, required?, minLength?) {
    const validators: ValidatorFn[] = [];
    if (required) {
      validators.push(Validators.required);
    }
    if (minLength !== undefined) {
      validators.push(Validators.minLength(minLength));
    }
    if (maxLength) {
      validators.push(Validators.maxLength(maxLength));
    }
    if (pattern) {
      validators.push(Validators.pattern(pattern));
    }
    return Validators.compose(validators);
  }

  onDropdownChangeCallbck(event) {
    this.addClaimDateForm.get('dateTimeQualifier').setValue(event);
    this.addClaimDateForm.get("hoursField").setValue("00");
    this.addClaimDateForm.get("minutesField").setValue("00");
    this.selectedQualifier = event;
    this.inputValue.dateTimeQualifier = event ? event.value : '';
    if (this.isDTTMFormatQualEditable() && this.addClaimDateForm.get('dateTimeFormatQual')) {
      let suggested = '';
      if (this.isInstitutional && this.inputValue.dateTimeQualifier === '435') {
        suggested = this.instFormatMap435[0];
      } else if (this.isInstitutional) {
        suggested = this.instFormatMap[this.inputValue.dateTimeQualifier];
      } else {
        suggested = this.profFormatMap[this.inputValue.dateTimeQualifier];
      }
      const found = this.listData["dateTimeFormatCode"].find(opt => opt.value === suggested);
      if (found) this.addClaimDateForm.get('dateTimeFormatQual').setValue(found);
    }
    this.validate();
  }
  
  onFormatDropdownChangeCallbck(event) {
    this.addClaimDateForm.get('dateTimeFormatQual').setValue(event);
    this.inputValue.dateTimeFormatQual = event ? event.value : '';
    this.validate();
  }

  validate() {
    const event = {
      type: 'validation',
      isInvalid: this.addClaimDateForm.status === "INVALID",
      field: this.inputLabel,
      qualifier: false,
      time: false,
      dateFrom: false,
      dateThrough: false,
      dateTimeFormatQual: false
    }
    this.validateFields(event);
    this.collapseAddClaimDatesEditor.emit(event);
  }

  isInvalidInput() {
    if (this.displayInputField()) {
      const hours = this.addClaimDateForm.get('hoursField').value;
      const minutes = this.addClaimDateForm.get('minutesField').value;
      return hours === "" && minutes === "";
    }
  }

  validateFields(event) {

    event['dateTimeQualifier'] = this.addClaimDateForm.controls.dateTimeQualifier.status === 'INVALID';

    if (this.displayInputField()) {
      event['time'] = this.isInvalidInput() || this.addClaimDateForm.controls.hoursField.status === 'INVALID' 
      || this.addClaimDateForm.controls.minutesField.status === 'INVALID';
    }  
    if(this.displayCodeFrom()){
      event['dateFrom'] = this.addClaimDateForm.controls.dateFromField.status === 'INVALID';
    }
    if (this.displayCodeThroughDate()) {
      event['dateThrough'] = this.isDateRangeInvalid() || this.addClaimDateForm.controls.dateThroughField.status === 'INVALID';
    }
    if(this.isDTTMFormatQualEditable()){
      // event['dateTimeFormatQual'] = this.addClaimDateForm.controls.dateTimeFormatQual.status === 'INVALID';
       // Enhanced validation for dateTimeFormatQual
       const dateTimeFormatControl = this.addClaimDateForm.controls.dateTimeFormatQual;
       event['dateTimeFormatQual'] = dateTimeFormatControl && dateTimeFormatControl.status === 'INVALID';
    }
  }

  changeClick() {

    Object.keys(this.addClaimDateForm.controls).forEach(key => {
      this.addClaimDateForm.controls[key].markAsTouched();
    });

    const event = {
      type: 'change',
      value: this.inputValue,
      field: this.inputLabel,
      isInvalid: false,
      dateTimeQualifier: false,
      time: false,
      dateFrom: false,
      dateThrough: false,
      dateTimeFormatQual: false
    }
    event.isInvalid = this.isDateRangeInvalid() || this.isInvalidInput() || this.addClaimDateForm.status === "INVALID";
    if (!event.isInvalid) {
      this.selectedQualifier = this.addClaimDateForm.get('dateTimeQualifier').value;
      this.inputValue.dateTimeQualifier = this.selectedQualifier ? this.selectedQualifier.value : '';
      this.updateAddClaimDateData(event);
    } else {
      this.validateFields(event);
    }
    this.collapseAddClaimDatesEditor.emit(event);
  }

  updateAddClaimDateData(event){
    if (this.displayInputField() && !this.displayCodeFrom()) {
      this.inputValue.dateTimePeriod = this.setInputFieldValue();
    } 
    if(this.displayCodeFrom()){
      this.inputValue.dateTimePeriod = this.encodeDateFormat(this.addClaimDateForm.get('dateFromField').value);
      if(this.displayInputField()){
        this.inputValue.dateTimePeriod += this.setInputFieldValue();
      }
    }
    if (this.displayCodeThroughDate()) {
      const dateFrom = this.displayCodeFrom() ? this.inputValue.dateTimePeriod + '-' : ""; 
      this.inputValue.dateTimePeriod =  dateFrom+ this.encodeDateFormat(this.addClaimDateForm.get('dateThroughField').value);
    }
    if(this.isDTTMFormatQualEditable()){
      this.inputValue.dateTimeFormatQual = (this.addClaimDateForm.get("dateTimeFormatQual").value).value;
    }
    //this.inputValue.dateTimeQualifier = (this.addClaimDateForm.get("dateTimeQualifier").value).value;
    event.value = this.inputValue;
  }

  setInputFieldValue() {
    const hoursValue = this.addClaimDateForm.get('hoursField').value;
    const minutesValue = this.addClaimDateForm.get('minutesField').value;
    const hours = (hoursValue === "" ? "00" : hoursValue.length === 1 ? "0" : "") + hoursValue;
    const minutes = (minutesValue === "" ? "00" : minutesValue.length === 1 ? "0" : "") + minutesValue;
    return hours + "" + minutes;
  }
  displayCodeThroughDate() {
    const selectedQualifier = this.addClaimDateForm?.get('dateTimeQualifier')?.value;
    const qualifierValue = selectedQualifier ? selectedQualifier.value : this.inputValue.dateTimeQualifier;
    return this.isServiceLineCategory ? this.inputValue.dateTimeFormatQual === 'RD8' : this.codeThroughQulList.indexOf(this.inputValue.dateTimeQualifier) !== -1;
  }

  displayInputField() {
    const selectedQualifier = this.addClaimDateForm?.get('dateTimeQualifier')?.value;
    const qualifierValue = selectedQualifier ? selectedQualifier.value : this.inputValue.dateTimeQualifier;
    return this.isInstitutional && (this.inputValue.dateTimeQualifier === this.inputFieldQualifier || (this.inputValue.dateTimeQualifier === "435" && this.addClaimDateForm && this.addClaimDateForm.get("dateTimeFormatQual") && (this.addClaimDateForm.get("dateTimeFormatQual").value).value === "DT" ));
  }

  displayCodeFrom(){
    const selectedQualifier = this.addClaimDateForm?.get('dateTimeQualifier')?.value;
    const qualifierValue = selectedQualifier ? selectedQualifier.value : this.inputValue.dateTimeQualifier;
    return this.isServiceLineCategory || ( this.inputValue.dateTimeQualifier !== this.qualifier361 && 
      !(this.isInstitutional && this.inputValue.dateTimeQualifier === this.inputFieldQualifier) ) ;
  }
  isDTTMFormatQualEditable(){
    const selectedQualifier = this.addClaimDateForm?.get('dateTimeQualifier')?.value;
    const qualifierValue = selectedQualifier ? selectedQualifier.value : this.inputValue.dateTimeQualifier;
    return qualifierValue && !this.inputValue.dateTimeFormatQual;
  }

  mousedownEvent(event) {
    event.preventDefault();
  }

  getFormControlValidity(frmControlNm) {
    let isInvalid: boolean = false;
    isInvalid = this.addClaimDateForm && this.addClaimDateForm.controls[frmControlNm].status === "INVALID";
    if (isInvalid && !this.viewLoaded) {
      this.validate();
    }
    return isInvalid;
  }

  isDateRangeInvalid() {
    if (this.displayCodeThroughDate() && this.displayCodeFrom()) {
      const fromDate = new Date(this.addClaimDateForm.get('dateFromField').value).getTime();
      const throughDate = new Date(this.addClaimDateForm.get('dateThroughField').value).getTime();
      return isNaN(throughDate) || isNaN(fromDate) || throughDate < fromDate;
    }
  }

  getSuggestedFormatOptions(): any[] {
    const qualifier = this.addClaimDateForm?.get('dateTimeQualifier')?.value?.value || this.inputValue.dateTimeQualifier;
    if (!qualifier) return [];
    if (this.isInstitutional && qualifier === '435') {
      // Admission for institutional: D8 and DT
      return this.listData["dateTimeFormatCode"].filter(opt => this.instFormatMap435.includes(opt.value));
    }
    if (this.isInstitutional) {
      const format = this.instFormatMap[qualifier];
      return format ? this.listData["dateTimeFormatCode"].filter(opt => opt.value === format) : [];
    }
    // Professional
    const format = this.profFormatMap[qualifier];
    return format ? this.listData["dateTimeFormatCode"].filter(opt => opt.value === format) : [];
  }
}
